import React from 'react';
import { dummyClick } from './utilities';

const ImgWithText = ({ img, text, onClick, alt }) => (
  <div className="clearfix full-width full-height" onClick={onClick} style={{ lineHeight: '62px' }}>
    <div className="left pl6 pr1 py5">
      <img className="left " src={img} alt={alt} width="46px" height="46px" />
    </div>
    <div className="left pr6 full-height">
      <span className="truncate block "> {text} </span>
    </div>
  </div>
)

ImgWithText.defaultProps = {
  onClick: dummyClick,
  alt: 'episode-logo-small',
  src: '/images/sample_images/sample_jpg.jpg',
  text: 'EN Episode Title'
};

export default ImgWithText;
